export default "__VITE_ASSET__DVWj1HbY__"